// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ExistingAsset } from '@/api/types';
import { OpenInNewRounded } from '@/constants/hardfin-standard-icons';
import { Link, Typography } from '@mui/material';

interface TakenSerialLinkProps {
  existingAsset: ExistingAsset;
}

/** Links to the asset that already carries a refused serial. */
export function TakenSerialLink(props: TakenSerialLinkProps) {
  return (
    <Typography variant="caption" color="text.secondary" px={2}>
      {'Used by asset '}
      <Link
        // A new tab keeps the dialog and its entered values.
        href={`/assets/${props.existingAsset.key}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          verticalAlign: 'baseline',
        }}
      >
        {props.existingAsset.serial}
        <OpenInNewRounded fontSize="inherit" />
      </Link>
    </Typography>
  );
}
